export default "__VITE_ASSET__BOYZw4nE__"